import { KYMW1205OutputModel } from './vo/kymw1205-output.model';

/**
 * 一括設定画面の値を管理するクラス
 *
 * @export KYMW1205Model
 * @class KYMW1205Model
 */
export class KYMW1205Model {
  pCode = '';

  output: KYMW1205OutputModel = new KYMW1205OutputModel();

}
